'use strict';

/*global app*/
/*global invokeCallback*/

function HandlingUnitService() {
  this.modal = null;

  this.init();
}

HandlingUnitService.prototype = $.extend({}, {
  constructor: 'HandlingUnitService',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    $('body').on('click', '.handling-unit__generate', function () {
      _this.generate();

      return false;
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  generate: function generate(callback) {
    var _this = this;

    app.confirmHtml(app.t('handling_unit.generate_confirm'), function (ret) {
      if (ret) {
        app.getFormation('handling_unit:generate', function (res) {
          if (res.msg === 'SUCCESS') {
            invokeCallback(callback, res.data);
          } else {
            app.viewErrorMessage(res.error);
          }
        });
      }
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.registerCallbacks();

    return _this;
  }
});
